/**
 * Return the server-provided retry delay for a normalized 429 ApiError.
 */
export const getRateLimitRetryAfterSeconds = (
  error: unknown,
): number | null => {
  if (
    typeof error !== 'object'
    || error === null
    || !('code' in error)
    || error.code !== 'RATE_LIMIT_EXCEEDED'
    || !('details' in error)
    || typeof error.details !== 'object'
    || error.details === null
    || !('retry_after' in error.details)
  ) {
    return null;
  }
  const seconds = Number(error.details.retry_after);
  return Number.isFinite(seconds) && seconds > 0
    ? Math.ceil(seconds)
    : null;
};
